/** Lowercase slug for application catalog identifiers (VYSOR setup-app + API). */
export const APPLICATION_SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export const APPLICATION_SLUG_MAX_LENGTH = 255;

export function normalizeApplicationSlug(raw: string): string {
  return raw.trim().toLowerCase();
}

/** Derive a catalog slug from a display name (Contoso HR Portal → contoso-hr-portal). */
export function suggestApplicationSlug(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-')
    .slice(0, APPLICATION_SLUG_MAX_LENGTH);
}

export function validateApplicationSlug(raw: string): string | null {
  const slug = normalizeApplicationSlug(raw);
  if (!slug) {
    return 'Application identifier is required.';
  }
  if (slug.length > APPLICATION_SLUG_MAX_LENGTH) {
    return `Use at most ${APPLICATION_SLUG_MAX_LENGTH} characters.`;
  }
  if (!APPLICATION_SLUG_PATTERN.test(slug)) {
    return 'Use lowercase letters, numbers, and hyphens only (e.g. "salesforce-prod"). No spaces or special characters.';
  }
  return null;
}
